export class ClientIconHelper {
  static getIcon(client: string, reason: string | null = null): string {
    // automatic unregistration
    if (reason === 'GeofenceExit' && client === '1anabapp') {
      return '🤖';
    }

    switch (client) {
      case '1anabapp':
        return '📱';
      case 'twilio':
        return '☎️';
      case 'manuelleanabmeldung':
        return '✍️';
      default:
        return '👤';
    }
  }
}
